import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Form, Input } from 'antd';
import { TrainingProjectsStore } from '../../stores';
import { trainingProjectFormFields } from '../../misc/constants';

interface Props {
    store: TrainingProjectsStore;
}

const TrainingProjectNameInput: React.FC<Props> = ({ store }) => {
    return (
        <Form.Item
            label="Name"
            name={trainingProjectFormFields.name}
            initialValue={store.editableTrainingProject ? store.editableTrainingProject.name : null}
            rules={[{ required: true, message: 'Please enter training project name!' }]}
        >
            <Input />
        </Form.Item>
    );
};

export default observer(TrainingProjectNameInput);
